<template>
  <div ref="tabsContainer" class="personal__tabs">
    <router-link
      v-for="({ routeName: name, title }) in tabs"
      :to="{ name }"
      class="personal__tab"
      :class="{ active: $route.name === name }"
      @click="handleTabClick"
    >
        {{ title }}
    </router-link>
  </div>
</template>

<script>
const TABS_GAP = 4
const TABS = [
  {
    routeName: 'profile:personal',
    title: 'Личные данные'
  },
  {
    routeName: 'profile:history',
    title: 'История заказов'
  },
  {
    routeName: 'profile:rewards',
    title: 'Бонусы'
  },
  {
    routeName: 'profile:addresses',
    title: 'Адреса доставки'
  }
]
export default {
  name: 'TheProfileTab',

  data() {
    return {
      tabs: TABS
    }
  },

  mounted() {
    this.scrollToTab()
  },

  methods: {
    handleTabClick(event) {
      this.scrollToTab(event.target)
    },

    scrollToTab(tabElement) {
      const tabsContainer = this.$refs.tabsContainer
      const tab = tabElement || tabsContainer.querySelector('.personal__tab.active')

      if (!tab) {
        return
      }

      const tabWidth = tab.offsetWidth
      const tabOffsetLeft = tab.offsetLeft
      const containerWidth = tabsContainer.offsetWidth

      const scrollPosition = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2) - (TABS.length * TABS_GAP)

      tabsContainer.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      })
    }
  }
}
</script>
